/*global angular*/
/*global _*/

import '../../../components/apptap/apptap';
import '../filters';

import jQuery from 'jquery';

angular.module('campaignLookupApp')
	// do initialization of the scope variable for attributes that are shared between controllers
	.config(['$provide', function ($provide) {
		$provide.value('initScope', function ($scope, $localStorage, $route) {
			$scope.pageType = "campaignLookup";
			$scope.searchCallout = "Search by App Name/ID or AppTap Offer ID";

			$scope.$storage = $localStorage.$default({
				campaignLookup: {}
			});

			$scope.app_sort = { comparison: 'stats.matched.weekRevenue', reverse: true };

			$scope.appPageSize = 100;
			$scope.maxApps = $scope.appPageSize;

			$scope.currentSearch = {};
			$scope.expanded = {};   //map appID --> bool : expanded row

			$scope.tooltips = {
				platforms: 'Must match at least one',
				attributes: 'Must match all selected attributes',
				countries: 'Must match at least one',
				payout: 'Must be greater than or equal to selection',
				d_source: 'Must match selection',
				p_source: 'Must match selection'
			};

			$scope.keyPress = function (event, term) {
				if (event.keyCode === 13) {
					$scope.search(term);
				}
			};

			$scope.availableCategories = [];

			if (typeof $scope.$storage.includeNoCap === 'undefined') {
				$scope.$storage.includeNoCap = false;
			}

			$scope.$storage.exactMatchOnly = false;
		});
	}])
	// this should be called last to finish initialization
	.service('Init', function () {
		return {
			run: function ($scope, AppTap, ngDialog, $q, $document, doSearch) {
				if (doSearch) {
					// override stored search if one exists on the url
					// if ($routeParams.search && $routeParams.search != 'undefined') {
					// 	$scope.$storage.search_term = $routeParams.search;
					// }
					// do search
					if (typeof $scope.$storage.search_term !== 'undefined') {
						$scope.search($scope.$storage.search_term);
					}
				}

				function getDemandSources() {
					var deferred = $q.defer();
					AppTap.getDemandSources({},
						function (data) {
							$scope.$storage.demandSources = data;
						},
						function () {
							deferred.reject();
							$scope.message = 'Error getting demand sources';
							ngDialog.open({
								template: 'apptap/dialogs/error.html',
								scope: $scope
							});
						},
						function () {
							deferred.resolve();
						}
					);
					return deferred.promise;
				}

				function getPublishers() {
					var deferred = $q.defer();
					AppTap.getPublishers({ clinkable: 'true' },
						function (data) {
							$scope.$storage.publishers = data;
						},
						function () {
							deferred.reject();
							$scope.message = 'Error getting publishers';
							ngDialog.open({
								template: 'apptap/dialogs/error.html',
								scope: $scope
							});
						},
						function () {
							deferred.resolve();
						}
					);
					return deferred.promise;
				}

				function getCategories() {
					var deferred = $q.defer();
					AppTap.getCategories({ platform: 'combined' },
						function (data) {
							if (data.apps && data.apps.length > 0) {
								for (var i = 0; i < data.apps.length; i++) {
									$scope.availableCategories.push({ name: data.apps[i] });
								}
							}
							if (data.games) {
								for (let i = 0; i < data.games.length; i++) {
									$scope.availableCategories.push({ name: data.games[i] });
								}
							}
						},
						function () {
							deferred.reject();
							$scope.message = 'Error getting categories';
							ngDialog.open({
								template: 'apptap/dialogs/error.html',
								scope: $scope
							});
						},
						function () {
							deferred.resolve();
						}
					);
					return deferred.promise;
				}

				getDemandSources().then(function () { });
				getPublishers().then(function () { });
				getCategories().then(function () { });

				$document.bind('keypress', function (e) {
					if (e.which === 13 /*enter*/) {
						ngDialog.closeAll();
						e.preventDefault();
						e.stopPropagation();
					}
				});
			}
		}
	})
	.controller('MainCtrl', ['$scope', 'AppTap', 'ngDialog', '$q', '$log', '$document', '$localStorage', '$filter', '$uibModal', '$rootScope', '$location', 'initScope', 'Init',
		function ($scope, AppTap, ngDialog, $q, $log, $document, $localStorage, $filter, $uibModal, $rootScope, $route, initScope, Init) {
			initScope($scope, $localStorage, $route);

			$scope.init = function() {
				$scope.currentUser = $scope.$ctrl.currentUser;
			}

			$scope.validSearch = function () {
				var errors = [];

				if (
					$scope.$storage.showPlatformFilter &&
					!$scope.$storage.android &&
					!$scope.$storage.iphone &&
					!$scope.$storage.ipad) {

					errors.push('Please select at least one platform');
				}
				return errors;
			};

			$scope.search = function (term) {
				$scope.errors = $scope.validSearch();
				if ($scope.errors.length > 0) {
					ngDialog.open({
						template: 'apptap/dialogs/listErrors.html',
						scope: $scope
					});
					return;
				}

				$scope.loading = true;
				$scope.matching_campaigns = 0;
				$scope.matching_clinks = 0;
				$scope.currentSearch = {};
				$scope.apps = null;

				if (term === null) term = '';

				getCampaigns(term).then(function () {
					//$scope.markRestrictedPlacementCampaigns();
					//$scope.markClinkedCampaigns();

					getPubNames().then(function () { });
				});
			};

			$scope.getTime = function (date) {
				if (date) {
					return new Date(date).getTime();
				}
				return null;
			};

			$scope.fetchAppData = function (app) {
				var deferred = $q.defer();

				var detailsSearch = jQuery.extend(true, {}, $scope.currentSearch);
				detailsSearch['appid'] = app.appID;

				var results = {}

				AppTap.campaigns(detailsSearch,
					function (resp) {
						var ret = null;
						_.each(resp.apps, function (a) {
							if (a.appID === app.appID) {
								ret = a;
								app.campaigns = a.campaigns;
								app.clinks = a.clinks;
							}
						});

						deferred.resolve(ret)
					},
					function () {
						deferred.reject();
						$scope.message = 'Could not query campaigns';
						ngDialog.open({
							template: 'apptap/dialogs/error.html',
							scope: $scope
						});
					},
					function () {
						$scope.loading = false;
						deferred.resolve(results['returned_app']);
					}
				);

				return deferred.promise;
			};

			var buildSearchParameters = function (term, appID) {
				var params = {
					'search': term,
					'returnStats': true,
					'returnCampaigns': true,
					'returnClinks': true,
					'includeNonMatchingCampaigns': true, // return all campaigns for each app so that we can show matching & non-matching
					'useExpandedSearchQuery': true,
				};

				var countries = null;
				if ($scope.$storage.showCountryFilter) {
					if ($scope.$storage.countries) {
						countries = $scope.$storage.countries;
					}

					params['countries'] = countries;
				}

				if ($scope.$storage.showCategoryFilter) {
					if ($scope.$storage.categories && $scope.$storage.categories.length > 0) {
						var categories = [];
						for (var i = 0; i < $scope.$storage.categories.length; i++) {
							categories.push($scope.$storage.categories[i].name);
						}
						params['categories'] = categories.join(",");
					}
				}

				var platforms = null;
				if ($scope.$storage.showPlatformFilter) {
					platforms = [];
					if ($scope.$storage.android) platforms.push('android');
					if ($scope.$storage.iphone) platforms.push('iphone');
					if ($scope.$storage.ipad) platforms.push('ipad');
					if (platforms.length === 3) {
						platforms = null; // pass nothing if all were selected
					} else {
						platforms = platforms.join(",");
					}

					if (platforms != null) {
						params['platforms'] = platforms;
					}
				}

				var clinkFilter = null;
				if ($scope.$storage.showClinksFilter) {
					if ($scope.$storage.clinkFilter && "ALL" !== $scope.$storage.clinkFilter) {
						clinkFilter = $scope.$storage.clinkFilter;
					}

					params['clinkFilter'] = clinkFilter;
				}

				var cpaFloor = null;
				if ($scope.$storage.showPayoutFilter) {
					cpaFloor = $scope.$storage.minPayout;

					params['includeCPA'] = true === $scope.$storage.includeCPA;
					params['includeCPI'] = true === $scope.$storage.includeCPI;

					params['includeEventsWellDefined'] = true === $scope.$storage.includeEventsWellDefined;
					params['includeEventsPoorlyDefined'] = true === $scope.$storage.includeEventsPoorlyDefined;

					params['minPayout'] = cpaFloor;
				}

				// APPTAP-6732 We used to send back the exclusion demand source list, now we send an inclusion list instead.
				/*
				var excludeDemandSources = null;
				if ( $scope.$storage.showSourceFilter ) {
					excludeDemandSources = ( $scope.$storage.ignoredDemandSources || [] ).join(",");
					params['excludeDemandSources'] = excludeDemandSources;
				}
				*/

				var includeDemandSources = null;
				if ($scope.$storage.showSourceFilter) {
					includeDemandSources = (_.difference(($scope.$storage.demandSources || []), ($scope.$storage.ignoredDemandSources || [])) || []).join(",");
					if (includeDemandSources) {
						params['allowDemandSources'] = includeDemandSources;
					}
					params['manualCampaignsOnly'] = true === $scope.$storage.manualCampaignsOnly;
				}

				if ($scope.$storage.showPlacementFilter) {
					params['placementFilter'] = $scope.$storage.placement;
				}

				var minKnownEvents = null;
				var maxKnownEvents = null;
				if ($scope.$storage.showPayoutFilter) {
					if ($scope.$storage.useMinKnownEvents) {
						minKnownEvents = $scope.$storage.minKnownEvents;
					}
					if ($scope.$storage.useMaxKnownEvents) {
						maxKnownEvents = $scope.$storage.maxKnownEvents;
					}
					params['minKnownEvents'] = minKnownEvents;
					params['maxKnownEvents'] = maxKnownEvents;
				}

				var minPayout = null;
				var maxPayout = null;
				if ($scope.$storage.showPayoutFilter) {
					if ($scope.$storage.useMinPayout) {
						minPayout = $scope.$storage.minPayout;
					}
					if ($scope.$storage.useMaxPayout) {
						maxPayout = $scope.$storage.maxPayout;
					}
					params['minPayout'] = minPayout;
					params['maxPayout'] = maxPayout;
				}

				var minHops = null;
				var maxHops = null;
				if ($scope.$storage.showHealthFilter) {
					if ($scope.$storage.useMinHops) {
						minHops = $scope.$storage.minHops;
					}
					if ($scope.$storage.useMaxHops) {
						maxHops = $scope.$storage.maxHops;
					}
					params['minHops'] = minHops;
					params['maxHops'] = maxHops;
				}

				var includeNoCap = true;
				var minInstallCap = null;
				var maxInstallCap = null;
				if ($scope.$storage.showCapFilter) {
					includeNoCap = $scope.$storage.includeNoCap;

					if ($scope.$storage.useMinInstallCap) {
						minInstallCap = $scope.$storage.minInstallCap;
					}
					if ($scope.$storage.useMaxInstallCap) {
						maxInstallCap = $scope.$storage.maxInstallCap;
					}

					params['includeNoCap'] = includeNoCap;
					params['minInstallCap'] = minInstallCap;
					params['maxInstallCap'] = maxInstallCap;
				}

				var minSources = null;
				var maxSources = null;
				if ($scope.$storage.showUniquenessFilter) {
					if ($scope.$storage.useMinSources) {
						minSources = $scope.$storage.minDemandSources;
					}
					if ($scope.$storage.useMaxSources) {
						maxSources = $scope.$storage.maxDemandSources;
					}

					params['minDemandSources'] = minSources;
					params['maxDemandSources'] = maxSources;
				}


				var includeDIDRequired = true;
				var includeDIDOptional = true;
				if ($scope.$storage.showDeviceIDFilter) {
					includeDIDRequired = true === $scope.$storage.includeDeviceIDRequired;
					includeDIDOptional = true === $scope.$storage.includeDeviceIDOptional;

					params['includeDIDRequired'] = includeDIDRequired;
					params['includeDIDOptional'] = includeDIDOptional;
				}

				if ($scope.$storage.showStatusFilter) {
					params['includeActive'] = true === $scope.$storage.showActive;
					params['includeInactive'] = true === $scope.$storage.showInactive;
					params['includeNotInFeed'] = true === $scope.$storage.showNotInFeed;
					params['includeNeedsApproval'] = true === $scope.$storage.showNeedsApproval;
					params['includeNoWhitelist'] = true === $scope.$storage.showNoWhitelist;
					params['includePayoutIssues'] = true === $scope.$storage.showPayoutIssues;
					params['includeRegionTargeted'] = true === $scope.$storage.showRegionTargeted;
					params['includeNonRegionTargeted'] = true === $scope.$storage.showNonRegionTargeted;
				}

				if ($scope.$storage.showHealthFilter) {
					params['includeHealthyQC'] = true === $scope.$storage.showHealthy;
					params['includeUnhealthyQC'] = true === $scope.$storage.showUnhealthy;
					params['includeBrokenStats'] = true === $scope.$storage.showStatsBroken;
					params['includeWorkingStats'] = true === $scope.$storage.showStatsWorking;
				}

				var includeIncent = true;
				var includeNonincent = true;

				if ($scope.$storage.showIncentFilter) {
					includeIncent = true === $scope.$storage.showIncent;
					includeNonincent = true === $scope.$storage.showNonincent;

					params['includeIncent'] = includeIncent;
					params['includeNonincent'] = includeNonincent;
				}

				if ($scope.$storage.showMaturityFilter) {
					params['includeMaturityEveryone'] = true === $scope.$storage.showMaturityEveryone;
					params['includeMaturityLow'] = true === $scope.$storage.showMaturityLow;
					params['includeMaturityMedium'] = true === $scope.$storage.showMaturityMedium;
					params['includeMaturityHigh'] = true === $scope.$storage.showMaturityHigh;
					params['includeMaturityUnrated'] = true === $scope.$storage.showMaturityUnrated;
				}

				if ($scope.$storage.showActivityFilter) {
					params['reqActivityClicks24h'] = true === $scope.$storage.showActivityClicks24h;
					params['reqActivityClicks7d'] = true === $scope.$storage.showActivityClicks7d;
					params['reqActivityInstalls24h'] = true === $scope.$storage.showActivityInstalls24h;
					params['reqActivityInstalls7d'] = true === $scope.$storage.showActivityInstalls7d;

					params['activityNearDailyCap'] = true === $scope.$storage.showActivityNearCap;
				}

				var includeSourceAppIDRequired = true;
				var includeSourceAppIDOptional = true;
				if ($scope.$storage.showSourceAppIDFilter) {
					includeSourceAppIDRequired = true === $scope.$storage.includeSourceAppIDRequired;
					includeSourceAppIDOptional = true === $scope.$storage.includeSourceAppIDOptional;

					params['includeSourceAppIDRequired'] = includeSourceAppIDRequired;
					params['includeSourceAppIDOptional'] = includeSourceAppIDOptional;
				}

				var includeSourceAppNameRequired = true;
				var includeSourceAppNameOptional = true;
				if ($scope.$storage.showSourceAppNameFilter) {
					includeSourceAppNameRequired = true === $scope.$storage.includeSourceAppNameRequired;
					includeSourceAppNameOptional = true === $scope.$storage.includeSourceAppNameOptional;

					params['includeSourceAppNameRequired'] = includeSourceAppNameRequired;
					params['includeSourceAppNameOptional'] = includeSourceAppNameOptional;
				}

				if ($scope.$storage.exactMatchOnly) {
					params['useExactMatchSearchQuery'] = true === $scope.$storage.exactMatchOnly;
				}

				return params;
			};

			var getCampaigns = function (term, appID) {
				var deferred = $q.defer();
				var cdn = 'https://s{INDEX}.api.apptap.com/img/';

				$scope.currentSearch = buildSearchParameters(term, appID);

				// this is redundant, now that we've set the tooltips to have .content as their parent (which gets wiped out every time we search)
				// $(".content .tooltip[role=tooltip]").remove();

				AppTap.campaigns($scope.currentSearch,
					function (resp) {
						resp = resp.apps;
						$scope.appsMatchingSearch = resp.length;

						$scope.apps = resp;
						$scope.matching_campaigns = 0;
						$scope.matching_clinks = 0;
						_.each($scope.apps, function(app) {
							// $scope.campaignsByApp[app.appID] = app.campaigns;
							// $scope.clinksByApp[app.appID] = app.clinks;

							// app.newSinceShort = '';
							// if (app.newSince) {
							// 	app.newSinceDate = $filter('iso8601ToString')(app.newSince, 'date');
							// 	app.newSinceTime = $filter('iso8601ToString')(app.newSince, 'time');
							// }

							$scope.matching_campaigns += app.counts.appMatchedCampaigns;
							$scope.matching_clinks += app.counts.appMatchedClinks;
							app.className = 'AT_' + app.appID.split('.').join('_');

							// get app icon resized through cdn
							if (app.icon) {
								app.icon = cdn.replace('{INDEX}', Math.floor(Math.random()*4)+1) + app.icon.substring(7) + '?s=45&type=icon';
							}

							return app;
						});
					},
					function () {
						deferred.reject();
						$scope.message = 'Could not query campaigns';
						ngDialog.open({
							template: 'apptap/dialogs/error.html',
							scope: $scope
						});
					},
					function () {
						$scope.loading = false;
						deferred.resolve();
					}
				);
				return deferred.promise;
			};

			$scope.exportCsv = function (includeHopDomains) {
				var search = buildSearchParameters($scope.$storage.search_term);
				search['export'] = 'csv';
				search['includeTrackingHopDomains'] = includeHopDomains;

				// conflict with react router
				// window.location = AppTap.join_paths(window.proxy, '/admin/campaigns/query?formattedOptimizations=true&' + jQuery.param(search));
				window.open('https://api.apptap.com/admin/campaigns/query?formattedOptimizations=true&' + jQuery.param(search));
			};

			var getPubNames = function () {
				var deferred = $q.defer();
				$scope.loadingPublishers = true;

				if ($scope.$storage.publishers) {
					deferred.resolve();
				}
				else {
					AppTap.getPublishers({ 'clinkable': true },
						function (data) {
							$scope.$storage.publishers = data;
						},
						function () {
							deferred.reject();
							$scope.message = 'Error getting publisher name';
							ngDialog.open({
								template: 'apptap/dialogs/error.html',
								scope: $scope
							});
						},
						function () {
							$scope.loadingPublishers = false;
							deferred.resolve();
						}
					);
				}
				return deferred.promise;
			};

			$scope.lookupPublisherName = function (pubID) {
				var name = $scope.$storage.publishers[pubID];
				if (name !== null) {
					return name;
				}
				return pubID;
			};

			$scope.getAppTitle = function () {
				for (var i = 0; i < $scope.apps.length; i++) {
					if ($scope.apps[i].appID === $scope.appID) {
						return $scope.apps[i].title;
					}
				}
			};

			$scope.getPlatforms = function () {
				var ret = [];
				if ($scope.$storage.android) {
					ret.push('android');
				}
				if ($scope.$storage.iphone) {
					ret.push('iphone');
				}
				if ($scope.$storage.ipad) {
					ret.push('ipad');
				}
				return ret;
			};

			$scope.showMoreApps = function () {
				$scope.maxApps += $scope.appPageSize;
			};

			$scope.removeClinkCampaign = function (campaign) {
				campaign.added = false;
				$scope.clinkCampaigns.splice($scope.clinkCampaigns.indexOf(campaign), 1);
				if ($scope.clinkCampaigns.length === 0) {
					$scope.appID = null;
				}
			};

			$scope.openCreativeDownload = function (appid) {
				window.open('/admin/campaigns/creative?download=true&appID=' + appid, '_blank');
			};

			/**
			 * Code to determine if the page being shown is for a reach partner user or for the admin user.
			 */
			$scope.isAdminUser = function() {
				var adminUser = window.permissions.indexOf('apptap:data:full-access') >= 0;
				return adminUser;
			};

			$scope.isAllowedRTBData = function() {
				var allowed = ( window.permissions.indexOf('apptap:data:full-access') >= 0 ) || ( window.permissions.indexOf('apptap:data:rtb') >= 0 )
				return allowed;
			}

			$scope.isAllowedGrossRevenueData = function() {
				var allowed = ( window.permissions.indexOf('apptap:data:full-access') >= 0 ) || ( window.permissions.indexOf('apptap:data:gross-revenue') >= 0 )
				return allowed;
			}

			$scope.canEditCLink = function() {
				// If the user has at least 1 scoped edit field, then they can edit clinks.
				return window.current_user['clinkEditScope'] && window.current_user['clinkEditScope'].length > 0;
			}
		
			$scope.canEditClinkField = function( field ) {
				var canEdit = false;
		
				if ( window.current_user['clinkEditScope'] ) {
					for ( const scopeField of window.current_user['clinkEditScope'] ) {
						if ( scopeField === 'ALL_FIELDS' ) {
							// If the current user can edit all clink fields, then return true for any requested field.
							canEdit = true;
							break;
						}
						else if ( scopeField === field ) {
							canEdit = true;
							break;
						}
					}
				}
		
				return canEdit;
			}

			$scope.editClink = function (id, closeDialogFnc) {
				// conflict with react router
				// $location.path('/modify/' + id);
				if (closeDialogFnc) {
					closeDialogFnc();
				}
			};

			$scope.open = function (app, campaign) {
				var createClink = $uibModal.open({
					templateUrl: './clink_modification/views/create/create.html',
					controller: 'CreateClinkCtrl',
					size: 'fullscreen',
					animation: false,
					windowClass: 'clink-mod modal-dialog-scrollable',
					resolve: {
						app: function () {
							return app;
						},
						campaigns: function () {
							if (campaign) {
								return [campaign];
							}
							else {
								return $filter('matchedCampaigns')(app.campaigns);
							}
						},
						allCampaigns: function () {
							return app.campaigns
						},
						clinks: function () {
							return app.clinks
						},
						existingClink: function () {
							return null;
						}
					}
				});

				createClink.result.then(function (clinkids) {
					// Fetch the updated list of cLinks for this app
					AppTap.getClinksForApp({ 'appid': app.appID },
						function (data) {	
							// merge in the new cLinks that were just added - this needs to be done
							// here, because the new cLinks won't have made it into the cached data
							// for campaigns yet, so we can't immediately call "fetchAppData" and get
							// the desired results
							_.each(data, function(clink) {
								if ( clinkids.indexOf( clink.clink_id ) >= 0 ) {
									app.clinks.push( clink );
								}
							});

							app.expanded = true;
							app.selectedTab = 'allClinks';
							$scope.$apply();

							// this won't work here, because various caches won't have updated quite yet.
							// app.clinks = data;
							// $scope.fetchAppData( app ).then( function() {
							// 	app.expanded = true;
							// 	app.selectedTab = 'allClinks';
							// 	$scope.apply();
							// });

							$scope.message = 'Created new cLinks:';
							$scope.clinkids = clinkids;
							ngDialog.open({
								template: 'apptap/dialogs/createdClink.html',
								scope: $scope
							});		
						},
						function () {
							// No need to do anything for the "fail" function.
							console.error("Failed to fetch the cLinks for app id: " + app.appID);
						},
						function () {
							// No need to do anything for the "complete" function.
						}
					);
				});
			};

			// reset all search parameters to their default values
			$scope.restore_defaults = function () {
				$scope.$storage.search_term = '';
				$scope.$storage.exactMatchOnly = false;

				$scope.$storage.showCapFilter = false;
				$scope.$storage.showClinksFilter = false;
				$scope.$storage.showCountryFilter = false;
				$scope.$storage.showCategoryFilter = false;
				$scope.$storage.showDeviceIDFilter = false;
				$scope.$storage.showHealthFilter = false;
				$scope.$storage.showIncentFilter = false;
				$scope.$storage.showNewSinceFilter = false;
				$scope.$storage.showPayoutFilter = false;
				$scope.$storage.showPlatformFilter = false;
				$scope.$storage.showPublisherFilter = false;
				$scope.$storage.showSourceFilter = false;
				$scope.$storage.showStatusFilter = false;
				$scope.$storage.showUniquenessFilter = false;
				$scope.$storage.showMaturityFilter = false;
				$scope.$storage.showStatsFilter = false;
				$scope.$storage.showActivityFilter = false;
				$scope.$storage.showPlacementFilter = false;
				$scope.$storage.showSourceAppIDFilter = false;
				$scope.$storage.showSourceAppNameFilter = false;
				$scope.$storage.showOwnerFilter = false;

				$scope.$storage.android = true;
				$scope.$storage.iphone = true;
				$scope.$storage.ipad = true;

				$scope.$storage.showActive = true;
				$scope.$storage.showInactive = true;
				$scope.$storage.showNotInFeed = false;
				$scope.$storage.showNeedsApproval = true;
				$scope.$storage.showNoWhitelist = true;
				$scope.$storage.showPayoutIssues = true;
				$scope.$storage.showRegionTargeted = true;
				$scope.$storage.showNonRegionTargeted = true;
				$scope.$storage.showIncent = true;
				$scope.$storage.showNonincent = true;
				$scope.$storage.showHealthy = true;
				$scope.$storage.showUnhealthy = true;

				$scope.$storage.deviceIDRequired = 'Any';
				$scope.$storage.dailyInstallCap = '';
				$scope.$storage.hideNonApproved = false;
				$scope.$storage.osVersion = 'Any';

				$scope.$storage.includeNoCap = false;
				$scope.$storage.useMinInstallCap = false;
				$scope.$storage.useMaxInstallCap = false;
				$scope.$storage.minInstallCap = '';
				$scope.$storage.maxInstallCap = '';

				$scope.$storage.clinkFilter = "ALL";

				$scope.$storage.countries = '';
				$scope.$storage.useMinPayout = false;
				$scope.$storage.useMaxPayout = false;
				$scope.$storage.minPayout = '';
				$scope.$storage.maxPayout = '';
				$scope.$storage.includeCPA = true;
				$scope.$storage.includeCPI = true;
				$scope.$storage.includeEventsWellDefined = true;
				$scope.$storage.includeEventsPoorlyDefined = true;
				$scope.$storage.useMinKnownEvents = false;
				$scope.$storage.useMaxKnownEvents = false;
				$scope.$storage.minKnownEvents = "";
				$scope.$storage.maxKnownEvents = "";

				$scope.$storage.ignoredDemandSources = [];
				$scope.$storage.ignoredPublishers = [];
				$scope.$storage.manualCampaignsOnly = false;

				$scope.$storage.newSinceDate = null;

				$scope.$storage.showMaturityEveryone = true;
				$scope.$storage.showMaturityLow = true;
				$scope.$storage.showMaturityMedium = true;
				$scope.$storage.showMaturityHigh = true;
				$scope.$storage.showMaturityUnrated = true;

				$scope.$storage.showStatsUnknown = true;
				$scope.$storage.showStatsBroken = true;
				$scope.$storage.showStatsWorking = true;
				$scope.$storage.showStatsSuspicious = true;

				$scope.$storage.showActivityClicks24h = false;
				$scope.$storage.showActivityClicks7d = false;
				$scope.$storage.showActivityInstalls24h = false;
				$scope.$storage.showActivityInstalls7d = false;
				$scope.$storage.showActivityNearCap = false;

				$scope.$storage.collapseCampaignsOnExport = true;
			};

			$scope.customizeDemandSource = function () {
				ngDialog.open({
					template: 'apptap/dialogs/customDemandSource.html',
					scope: $scope
				});
			};

			$scope.getDemandSourcesBeingUsed = function () {
				return _.filter($scope.demandSources, function (source) {
					if (!_.contains($scope.$storage.ignoredDemandSources, source)) {
						return source;
					}
				});
			};

			$scope.compare = {
				payoutMin: function (x) {
					return 1 * x.payoutMin.replace('$', '');
				},
				payoutMax: function (x) {
					return 1 * x.payoutMax.replace('$', '');
				},
				newSince: function (x) {
					return !x.newSince
						? new Date("1970-01-01T00:00:00Z")
						: new Date(x.newSince);
				},
			};

			Init.run($scope, AppTap, ngDialog, $q, $document, true);
		}]);













